 import {createContext} from 'react';

const SimpleContext = createContext({
    goBrand:false, setgoBrand:false,
    uisetting:{}, setuisetting:{},
    latCenter:[], setlatCenter:[],
    festivalData:{}, setFestivalData:{},
    FestivalDataPoints:{}, setFestivalDataPoints:{},
    langCenter:[], setlangCenter:[],
    userIdMap:[], setuserIdMap:[],
    orderDetailId:0, setorderDetailId:0,
    UserLang:[], setUserLang:[],
    UserLat:[], setUserLat:[],
    orderDetailApi:[], setorderDetailApi:[],
    orderDetailKfp:[], setorderDetailKfp:[],
    page:0, setpage:0,
    searchBodyOfProduct:{}, setsearchBodyOfProduct:{},
    showPrepage:false, setshowPrepage:false,
    productRoight:"/product", setproductRoight:"/product",
    productsDetails:[], setproductsDetails:[],
    BrandIdForUser:-1, setBrandIdForUser:-1,
    brandsOfDis:[], setbrandsOfDis:[],
    showCountIn:false, seshowCountIn:false,
    detailsOfOrders:[], setdetailsOfOrders:[],
    phoneOfSupport:[], setphoneOfSupport:[],
    notExistRes:"", setnotExistRes:"",
    gerami:false, setgerami:false,
    unitProduct:[], setunitProduct:[],
    showmodalNum:false, setshowmodalNum:false,
    addpre:false, setaddpre:false,
    addRes:{}, setaddRes:{},
    addg:[], setaddg:[],
    add:[], setadd:[],
    resOfSelect:{}, setresOfSelect:{},
    showmodalNumProduct:false, setshowmodalNumProduct:false,
    showmodalNumBasket:false, setshowmodalNumBasket:false,
    productNumBasket:{}, setproductNumBasket:{},
    IsLoadingBasket:true, setIsLoadingBasket:true,
    preCount:false, setpreCount:false,
    selectbutton:false, setselectbutton:false,
    validModal:false, setvalidModal:false,
    productNum:[], setproductNum:[],
    dis:0, setdis:0,
    bouhgt:0, setbouhgt:0,
    fave:0, setfave:0,
    rullsText:"", setrullsText:"",
    showapi:false, setShowApi:false,
    showKfp:false, setShowKfp:false,
    Kfp:[], setKfp:[],
    api:[], setapi:[],
    IsLoggeCode:false, setIsLoggeCode:false,
    IsLoggedWithSms:false, setIsLoggedWithSms:false,
    enterpassUser:[], setenterpassUser:[],
    userPassword:[], setuserPassword:[],
    userCodeMap:[], setuserCodeMap:[],
    userPhoneMap:[], setuserPhoneMap:[],
    Pass:[], setPass:[],
    ConfirmPass:[], setConfirmPass:[],
    setPassModal:false, setsetPassModal:false,
    codeOfUser:0, setcodeofUser:0,
    enterpass:[], setenterpass:[],
    preButton:false, setpreButton:false,
    errorText:"", seterrorText:"",
    errorshow:false, seterrorshow:false,
    showChat:[], setshowChat:[],
    ToastError:false, setToastError:false,
    Handelerror:()=>{},
    HandelShowContentPage2:()=>{},
    callPoints:()=>{},
    BadgeOfBasket:"", setBadgeOfBasket:"",
    BrandOfId:[], setBrandOfId:[],
    AppType:0, setAppType:0,
    brandName:"", setbrandName:"",
    changeView:true, setchangeView:true,
    toast:[], setToast:[],
    showToast:false, setShowToast:false,
    showToast2:false, setShowToast2:false,
    sort:0, setsort:0,
    List:[], setList:[],
    showBrand:false, setshowBrand:false,
    homepageBanner:[], sethomepageBanner:[],
    getBrandsList:[], setgetBrandsList:[],
    showCatId:0, setshowCatId:0,
    headerCat:[], setheaderCat:[],
    TextPopUp:{}, setTextPopUp:{},
    link:[], setlink:[],
    modalPopUp:false, setmodalPopUp:false,
    discountStep:{}, setdiscountStep:{},
    showCat:false, setshowCat:false,
    TarhaTitle:[], setTarhaTitle:[],
    deleteAllBrandsInSearch:false, setdeleteAllBrandsInSearch:false,
    SearchBrandsSelection:'minibrandImgunselected', setSearchBrandsSelection:'minibrandImgunselected',
    show:[],setshow:[],
    SelectedBrandsList:[], setSelectedBrandsList:[],
    FilterPriceRange:[], setFilterPriceRange:[],
    resAdd:false, setresAdd:false,
    TreeMenuSelectedId:0, setTreeMenuSelectedId:0,
    showfield:false, setshowfield:false,
    baseUrlApiPakhsh :"https://apipakhsh.ir",
    //  baseUrlApiPakhsh : "https://dev2ak.igzas.ir",
    // baseUrlApiPakhsh :"https://apipakhshv3.igzas.ir",
    // baseUrlApiPakhsh :"https://apipakhshv3.igzas.ir",
    SearchField:"",setSearchField:"",
    pre:false, setpre:false,
    Tarha:[], setTarha:[],
    timeMiliSecondRes:[],settimeMiliSecondRes:[],
    timeMiliSecondDef:[],settimeMiliSecondDef:[],
    showPre:false, setshowPre:false,
    UniqueUUID:0, setUniqueUUID:0,
    showModalTime:false,setshowModalTime:false,
    MyBasketItems:[],setMyBasketItems:[],
    FirstBasket:[], setFirstBasket:[],
    basket:false, setBasket:false,
    basketloader:false,setbasketloader:false,
    theme:'',
    searchProducts:{}, setsearchProducts:{},
    MyId:0, setMyId:0,
    brands:[],
    tarikh: [],
    products:[],
    category:[],
    Discount:[],
    SimplePrd:[],
    category3C:[],
    productCopy:[],
    allProducts: [],
    offerBanners:[],
    category_two: [],
    productsLevel2:[],
    DiscountGroups:[],
    FirstPageTotal:[],
    filteredProducts: [],
    SearchedProducts: [],
    tarikhTahvilKala: [],
    FilteredTarhydar: [],
    FilteredByImgTarh:[],
    FreshProductsList:[],
    ShopedProductList: [],
    FilteredFreshPro:[],
    FreshSearchedProducts: [],
    FreshListFSearch:[],
    myTarhs:[],
    setmyTarhs:[],
    propsForDescount:{},
    setfreshSearchtxt:'',
    freshSearchtxt:'',
    row1:[],
    setrow1:[],
    row2:[],
    setrow2:[],
    row3:[],
    setrow3:[],
    row4:[],
    setrow4:[],
    row5:[],
    setrow5:[],
    row6:[],
    setrow6:[],
    row7:[],
    setrow7:[],
    row8:[],
    setrow8:[],
    setSabad:{},
    Sabad:{},    
    IsShowOne: [],
    setIsShowOne: [],
    setOffers:[],
    Offers:[],
    myinfo:[],
    setmyinfo:[],
    setimagenames:[],
    imagenames:[],
    banner3Info:[],
    setbanner3Info:[],
    banner4Info:[],
    setbanner4Info:[],
    bannerProduct:[],
    setbannerProduct:[],
    TarhdarImages:[],
    setTarhdarImages:[],
    TarhNameHeader:[],
    MainCat:[],
    setMainCat:[],
    SinglePrdCategory:[],
    setSinglePrdCategory:[],
    SinglePrdCategory2:[],
    setSinglePrdCategory2:[],
    loopArr:[],
    clicked:false,
    setClicked:'',
    verCode: 0, 
    setVerCode: 0,
    hi:[],
    setHi:[],
    catNameHeader:[],
    productNameHeader:[],
    setShopedProductList:[],
    setListt:[],
    Listt:[],
    Acts:[],
    category:[], setCategory:[],
    contentPage: '1',
    sideDrawer: false,
    SearchDrawer: false,
    TarhdarDrawer: false,
    Error:false, setError:false,
    ToastMsge:"", setToastMsge:"",
    CatLoader:false, setCatLoader:false,
    ProductDrawer: false,
    FreshSearchDrawer: false,
    searchtxt: ' ',
    setsearchtxt : '',
    setModalShow:false,
    modalShow:false,
    DiscCode: [],
    setDiscCode: [],
    CartItems:[],
    setCartItems:[],
    FRESHCartItems:[],
    setFRESHCartItems:[],
    PrdCount: [],
    setNumUnitDiscount: 0,
    NumUnitDiscount: 0,
    setStyle:'TarhNamePlace',
    style:'TarhNamePlace',
    setNumber: 0,
    number: 0,
    setTTotalPrice:0,
    TTotalPrice:0,
    setFreshTTotalPrice: 0,
    FreshTTotalPrice: 0,
    SumTarh:0,
    MyList:[],
    varaanegar_stock: [],
    setSabadResponse:[],
    SabadResponse:[],
    setFreshSabadResponse: [],
    FreshSabadResponse: [],
    StockProduct:[], setStockProduct:[],
    FreshStockProduct:[], setFreshStockProduct:[],
    ApiFactors:[], setApiFactors:[],
    KFPfactors:[], setKFPfactors:[],
    Freshfactors:[], setFreshfactors:[],
    getVaranegarOrderResponse:[], setgetVaranegarOrderResponse:[],
    getInsertOrderResponse:[], setgetInsertOrderResponse:[],
    FreshInsertOrderResponse:[], setFreshInsertOrderResponse:[],
    UseInFo:{},setUseInFo:{},
    justFav:0, setjustFav:0,
    bothId:0, setbothId:0,
    FullDate:'',
    ApiSetting:{},
    Maximum:[],setMaximum:[],
    ApiFactorResponse:[], setApiFactorResponse:[],
    KFPFactorResponse:[], setKFPFactorResponse:[],
    PreOrderFactorResponse:[], setPreOrderFactorResponse:[],
    DeliveryDateFresh:[],
    IsLoggedIn:false, setIsLoggedIn:false,
    IsLoggedIn2:false, setIsLoggedIn2:false,
    NotRegisteredAtCO:false, setNotRegisteredAtCO:false,
    getFinalFreshResponse:[], setFinalFreshResponse:[],
    resAddToCart:{}, setresAddToCart:{},
    mapLoader:false, setmapLoader:false,
    goOrders:()=>{},
    handleError:()=>{},
    goFavorate:()=>{},
    productDetails:()=>{},
    disBrands:()=>{},
    details:()=>{},
    support:()=>{},
    notExistCustomer:()=>{},
    sabteSefaresh:()=>{},
    KfPorder:()=>{},
    CustomerOrder:()=>{},
    handleAddToCardD:()=>{},
    loginUser2:()=>{},
    modify:()=>{},
    loginUser:()=>{},
    postloc:()=>{},
    sendCode:()=>{},
    checkcustomer:()=>{},
    countRowBaskett:()=>{},
    sortOrder:()=>{},
    gethomepage:()=>{},
    getBrands:()=>{},
    categories:()=>{},
    tarh:()=>{},
    handleAddToCard:()=>{},
    search:()=>{},
    Encriptor:()=>{},
    handleClickOnMyApiItems: () => {},
    badgeNum: () => {},
    loadBasket: () => {},
    click:()=>{},
    handleAddProduct: () => {},
    handleOpenSearch: () => {},
    handlefreshFilter: () => {},
    clearLocalStorage: () => {},
    handleCloseSearch: () => {},
    handleHistoryPush: () => {},
    handleCloseSidebar: () => {},
    handleRemoveProduct: () => {},
    handleTarhdarDrawer: () => {},
    handleProductDrawer: () => {},
    handleFilterTarhDar: () => {},
    handleHistoryreplace: () => {},
    backdropClickHandler: () => {},
    handleFilterProducts: () => {},
    handleFilterCategory: () => {},
    HandelShowContentPage: () => {},
    handleFilterByCatName: () => {},
    handleSearchProducts : () => {},
    handleFilterCategory3: () => {},
    handleFreshProductList: () => {},
    homepageOnClickBanners: () => {},
    handleCloseFreshSearch: () => {},
    handleShowFilteredTarhs: () => {},
    handleShowSimpleProduct: () => {},
    handleShowSingleProduct: () => {},
    handleShowShopedProducts: () => {},
    drawerToggleClickHandler: () => {},
    handleDeleteItemFromSabad: () => {},
    handleFilterProducts_LevTwo: () => {},
    handleFilteredFreshSearched: () => {},
    handleShowTrhsFilteredBySlugName: () => {},
    handleShowCategoryLevelThreeProducts: ()=>{},
    handleShowCategoryLevelTwoProducts: () => {},
    AddBasketFromSimpleProductSlider: () => {},
    handleDeleteFRESHItemFromSabad: () => {},
    FRESHbadgeNum: () => {},
    handleAddFRESHProduct: () => {},
    handleRemoveFRESHProduct: () => {},
    Varanegar_Discountfresh: () => {},
    Varanegar_Discount: () => {},
    festivalPont: () => {}

});

export default SimpleContext;